export default __webpack_public_path__ + "0f5a611d1426c46ad7f4723d982ca3bb.png";